import { css } from '@emotion/css';

export const inputPinContainer = css`
  .heading {
    margin: 100px 0 40px 0;
    font-size: 16px;
    font-weight: bold;
  }

  .error-text {
    font-size: 1rem;
    line-height: 1.33;
    text-align: center;
    color: #db4d3d;
    margin-top: 16px;
  }
`;

export const inputPinPage = css`
  background: #fff;
  min-height: 100vh;
`;
